import { CellContext } from '@tanstack/react-table';
import { TFunction } from 'i18next';

const dateValue = (date: unknown): Date | undefined => {
  if (date instanceof Date) return date;
  if (typeof date === 'string' || typeof date === 'number') return new Date(date);
  return undefined;
};

type FormatKey = 'datetime.short' | 'datetime.long' | 'date.short' | 'date.long';

const DEFAULT_FORMAT: FormatKey = 'datetime.short';

const useFormatCellAsDate =
  <T,>(t: TFunction, format: FormatKey = DEFAULT_FORMAT) =>
  (row: CellContext<T, unknown>): string | undefined => {
    const value = row.getValue();
    if (!value) return '';
    return t(format, { date: dateValue(value) });
  };

type CellDateFormatter<T> = ReturnType<typeof useFormatCellAsDate<T>>;

export type { CellDateFormatter };
export { useFormatCellAsDate };
